<div class="document-preview-header">
  <h4 class="document-preview-title">{{ title }}</h4>
</div>
<div class="form-modal-body document-preview-body">
  <ng-container *ngIf="previewUrl; else noPreview">
    <img *ngIf="isImage" [src]="previewUrl" alt="Preview" class="document-preview-image" />
    <iframe *ngIf="!isImage" [src]="previewUrl" class="document-preview-frame" title="Document preview"></iframe>
  </ng-container>
  <ng-template #noPreview>
    <div class="p-3 text-muted text-center">No preview available.</div>
  </ng-template>
</div>
<div class="form-modal-footer p-3">
  <div class="justify-content-center modal-actions">
    <button type="button" class="btn document-preview-cancel px-3 py-1" (click)="activeModal.dismiss()">Close</button>
  </div>
</div>
